export const fmtDate = (d) => {
  const [dd, mm] = d.split(".")
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ]
  return `${dd} ${months[parseInt(mm, 10) - 1]}`
}

export function money(v, currency) {
  const amount = (v ?? 0).toLocaleString("en-US", { minimumFractionDigits: 0 })
  if (!currency) return amount
  return `${amount} ${currency === "EUR" ? "€" : currency}`
}

export const formatLocalizedDate = (dateString, locale) => {
  return new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(dateString))
}
